export default {
  bouyguesAssistance: {
    id: 'checkout_services_bouygues_phoneline_setup_bouygues_assistance',
    defaultMessage: 'Bouygues assistance',
  },
}
